import React from 'react';
import { formatDate } from '@shootsta/get-moment';
import { downloadFile, getUser } from '../../../../../common/utils';
import UserProfile from '../../../common/UserProfile';
import AssetPreview from '../../../../AssetPreview';
import { Accordion, LucideIcon as Icon, Link, List, Text } from '../../../../../ui-kit';
import { Image as ImageIcon, Video, Music, FileX, Download, Paperclip, ChevronDown, ChevronUp } from 'lucide-react';
import ContentView from '../../ContentView';
import '../styles/_comments-list-v2.scss';

const INITIAL_REPLIES_COUNT = 2;

function getPrefix(type) {
  switch (type) {
    case 'image':
      return ImageIcon;
    case 'video':
      return Video;
    case 'audio':
      return Music;
    default:
      return FileX;
  }
}

function CommentAttachment({
  assetId,
  assetsMap



}) {
  const attachmentDetails = React.useMemo(() => {
    if (assetsMap) {
      const assetDetails = assetsMap.get(assetId);
      const { title, metaData } = assetDetails || {};
      const meta = metaData ? JSON.parse(metaData) : null;

      return {
        title: title || 'Unknown',
        type: meta && meta.type ? meta.type.split('/')[0] : ''
      };
    }
    return {
      title: 'Unknown',
      type: ''
    };
  }, [assetsMap]);

  return (
    <div>
      {/* $FlowFixMe */}
      <List.CardItem>
        <div className="card-item__content--title">
          <Icon icon={getPrefix(attachmentDetails.type)} />
          <Text heading5>{attachmentDetails.title}</Text>
        </div>
        <Icon
          size={16}
          icon={Download}
          color="regent"
          hoverColor="darkDenim"
          onClick={() => downloadFile({ assetId, assetFiles: 'ORIGINAL' })}
          wrapperClassName="flex items-center justify-center h-7 w-7 rounded-full cursor-pointer transition-colors duration-150 hover:bg-gray-100" />
      </List.CardItem>
    </div>);

}

function CommentReply({
  replies,
  allRepliesVisible,
  assetsMap




}) {
  if (!replies.length) {return null;}

  const visibleReplies = allRepliesVisible ?
  replies :
  replies.slice(replies.length - INITIAL_REPLIES_COUNT, replies.length);

  return (
    <div>
      {visibleReplies.map(({ commentId, content, createdByUser, updatedAt, assetIds = [] }) =>
      <div
        className="comments-list-v2__card-item--content--replies__reply"
        key={commentId}>

          <div
          className="comments-list-v2__card-item--content--replies__reply--content">

            <ContentView content={content} truncate />
            {assetIds.length > 0 ? assetIds.map((assetId) =>
          <CommentAttachment
            assetId={assetId}
            assetsMap={assetsMap} />

          ) : null}
          </div>
          <UserProfile
          imageUrl={createdByUser.imageUrl}
          name={`${createdByUser.firstName} ${createdByUser.lastName}`}
          isUser={createdByUser.isUser} />

          <div className="comments-list-v2__card-item--content__wrapper--timestamp">
            <Text noMargin timestamp>{formatDate(updatedAt, 'DD MMM, YYYY [at] hh:mm A')}</Text>
          </div>
        </div>
      )}
    </div>);

}

function Comment({
  comment,
  getFormattedTimestamp,
  assetsMap




}) {
  const {
    assetId,
    assetIds = [],
    commentAssetId,
    content,
    timestamp,
    children: replies,
    createdByUser,
    updatedAt,
    xPercent,
    yPercent
  } = comment;

  const { name, imageUrl, isUser } = getUser(createdByUser);
  const [allRepliesVisible, toggleRepliesVisibility] = React.useState(false);
  const commentDetails = React.useMemo(() => {
    if (assetsMap) {
      const assetDetails = assetsMap.get(commentAssetId);
      const { title, metaData } = assetDetails || {};
      const meta = metaData ? JSON.parse(metaData) : null;

      return {
        title: title || 'Unknown',
        type: meta && meta.type ? meta.type.split('/')[0] : ''
      };
    }
    return {
      title: 'Unknown',
      type: ''
    };
  }, [assetsMap]);

  function getAxis(axis) {
    if (axis > 85) {
      return `${axis}% - 16px`;
    }if (axis < 20) {
      return `${axis}% + 16px`;
    }

    return `${axis}%`;
  }

  return (
    <div>
      {/* $FlowFixMe */}
      <List.CardItem className="comments-list-v2__card-item">
        <Accordion
          titles={{
            label: commentDetails.title || '',
            prefix: getPrefix(commentDetails.type),
            subtitle: commentDetails.type
          }}
          className="comments-list-v2__card-item--content"
          suffix={`Attachment(${assetIds.length})`}
          initialOpenAll>

          <>
            <div className="comments-list-v2__card-item--content__wrapper">
              <div className="comments-list-v2__card-item--content__wrapper--asset">
                <div>
                  <div className="comments-list-v2__card-item--content__wrapper--asset-preview">
                    <div
                      className="comments-list-v2__card-item--content__wrapper--asset-preview__dot"
                      style={{
                        zIndex: 5,
                        position: 'relative',
                        left: `calc(${getAxis(xPercent)})`,
                        top: `calc(${getAxis(yPercent)})`
                      }} />

                    <AssetPreview
                      assetId={commentAssetId}
                      height={80}
                      width={142}
                      hideFileTypeIcon />

                  </div>
                </div>
                <div className="comments-list-v2__card-item--content__wrapper--heading">
                  <Text
                    heading5
                    className="comments-list-v2__card-item--content__wrapper--heading__duration">

                    {getFormattedTimestamp(timestamp)}
                    {assetIds.length > 0 &&
                    <Icon icon={Paperclip} size={16} />}

                  </Text>
                  <ContentView content={content} truncate />
                </div>
              </div>
              <div className="comments-list-v2__card-item--content__wrapper--user">
                <UserProfile
                  imageUrl={imageUrl}
                  name={name}
                  isUser={isUser} />

              </div>
              <div className="comments-list-v2__card-item--content__wrapper--timestamp">
                <Text noMargin timestamp>{formatDate(updatedAt, 'DD MMM, YYYY [at] hh:mm A')}</Text>
              </div>
            </div>
            {replies.length ?
            <div className="comments-list-v2__card-item--content--replies">

                <div className="comments-list-v2__card-item--content__wrapper--heading__collapse">
                  <Icon
                  icon={allRepliesVisible ? ChevronUp : ChevronDown}
                  size={12} />

                  <Link
                  button
                  onClick={() => toggleRepliesVisibility(!allRepliesVisible)}>

                    {`${allRepliesVisible ? 'Hide' : 'Show'} ${replies.length} replies`}
                  </Link>
                </div>

                {allRepliesVisible &&
              <div>
                  <CommentReply
                  allRepliesVisible={allRepliesVisible}
                  replies={replies}
                  assetsMap={assetsMap} />

                  {assetIds.length > 0 ? assetIds.map((_assetId) =>
                <div
                  className="comments-list-v2__card-item--content--replies__reply"
                  key={_assetId}>

                      <div
                    className="comments-list-v2__card-item--content--replies__reply--content comments-list-v2__card-item--content--replies__reply--attachments">

                        <CommentAttachment
                      assetId={_assetId}
                      assetsMap={assetsMap} />

                      </div>
                    </div>
                ) : null}
                  {assetId ?
                <div
                  className="comments-list-v2__card-item--content--replies__reply"
                  key={assetId}>

                      <div
                    className="comments-list-v2__card-item--content--replies__reply--content comments-list-v2__card-item--content--replies__reply--attachments">

                        <CommentAttachment
                      assetId={assetId}
                      assetsMap={assetsMap} />

                      </div>
                    </div> :
                null}
                </div>}

              </div> :
            null}
          </>
        </Accordion>
      </List.CardItem>
    </div>);

}

function CommentsListV2({
  visibleComments,
  getFormattedTimestamp,
  fetchAssets,
  assetsMap





}) {
  let assetToLoad = [];

  const fetchAsset = async () => {
    await fetchAssets({ assetIds: assetToLoad });
  };

  React.useMemo(() => {
    if (visibleComments && visibleComments.length) {
      visibleComments.map(({ assetId, assetIds = [], commentAssetId = '', children = [] }) => {
        if (children.length > 0) {
          children.map(({ assetIds: replyAssetIds }) => {
            assetToLoad = [...assetToLoad, ...assetIds, ...replyAssetIds, assetId, commentAssetId];
            return true;
          });
          return true;
        }
        assetToLoad = [...assetToLoad, ...assetIds, assetId, commentAssetId];
        return true;
      });
    }

    if (assetToLoad) {
      fetchAsset();
    }
  }, [visibleComments]);

  return (
    <div className="comments-list-v2">
      {visibleComments.length > 0 ? visibleComments.map((comment) =>
      <Comment
        comment={comment}
        getFormattedTimestamp={getFormattedTimestamp}
        fetchAssets={fetchAssets}
        assetsMap={assetsMap} />

      ) : null}
    </div>);

}

export default CommentsListV2;